import About from './About';
import Gallery from './Gallery';
import Services from './Services';
import Footer from './Footer';
// import Testimonials from './Testimonials';
import TempleName from './TempleName'
import TempleActivities from './TempleActivities'
import Event from './Event';
import WhatWeDo from './WhatWeDo';
// import LeaveAMessage from './LeaveAMessage';
import Slider from './Slider';
import MenuBar from './MenuBar';
import Sidebar from './Sidebar';
import SidebarMenu from '../../Canada/Component/SidebarMenu';
import LatestEventsSection from './LatestEventsSection';
import GrandInuagration from './GrandInuagration';
import DepartmentsSection from './departments/DepartmentsSection';
import './VolunteerCTA.css';



const Home = () => {
    return (
        <>
            <div className="page-wrapper">


                {/* <!-- Main Header --> */}
                {/* <Header/> */}
                <MenuBar />

                <Sidebar />


                {/* <!-- End Main Header --> */}





                {/* <!-- End Main Header --> */}
                {/* <!-- new Section start here --> */}

                {/* <GrandInuagration /> */}




                {/* <!-- new Section start here --> */}

                {/* Latest Events Section - API Integration */}
                {/* <LatestEventsSection /> */}

                {/* Yugal Kunj Services Section */}
                <Services />

                {/* <!--About Section--> */}
                <About />


                <WhatWeDo />

                {/* YK-USA Coordination Team Departments */}
                {/* <DepartmentsSection /> */}


                {/*  Slider */}
                {/* <Slider /> */}



                {/*  Gallerry Section start here */}


                {/* <Gallery /> */}

                {/*  Temple description  */}

                <TempleName />


                <Event />

                <TempleActivities />

                {/* <Testimonials />  */}
                {/* 
                <LeaveAMessage /> */}

                {/* <!-- Main Footer --> */}

                {/* ── Volunteer Call-to-Action ── */}
                <div className="yk-volunteer-cta">
                    <div className="yk-volunteer-card">
                        <div className="yk-volunteer-inner">

                            {/* Left content */}
                            <div className="yk-volunteer-content">
                                <h2 className="yk-volunteer-heading">
                                    Become a vital part of Yugal Kunj &amp; make a real difference to lives of many!
                                </h2>
                                <p className="yk-volunteer-sub">
                                    Contribute your time and heart to spreading selfless devotion and serving God's creation alongside our community.
                                </p>
                            </div>

                            {/* Right CTA */}
                            <div className="yk-volunteer-cta-wrap">
                                <a
                                    href="https://portalyk.yugalkunj.org/#/volunteer/register"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="yk-volunteer-btn"
                                >
                                    Join to Volunteer
                                    <span className="yk-volunteer-btn-arrow" aria-hidden="true">→</span>
                                </a>
                                <span className="yk-volunteer-note">Free to join &nbsp;·&nbsp; Open to all ages</span>
                            </div>

                        </div>
                    </div>
                </div>

                <Footer />


            </div>




        </>
    );
}

export default Home;
